export default function isGDPR(countryCode) {
  const countries = {
    AUSTRIA: "AU",
    BELGIUM: "BE",
    BULGARIA: "BG",
    CROATIA: "HR",
    CYPRUS: "CY",
    "CZECH REPUBLIC": "CZ",
    DENMARK: "DK",
    ESTONIA: "EE",
    FINLAND: "FI",
    FRANCE: "FR",
    GERMANY: "DE",
    GREECE: "GR",
    HUNGARY: "HU",
    IRELAND: "IE",
    ITALY: "IT",
    LATVIA: "LV",
    LITHUANIA: "LT",
    LUXEMBOURG: "LU",
    MALTA: "MT",
    NETHERLANDS: "NL",
    POLAND: "PL",
    PORTUGAL: "PT",
    ROMANIA: "RO",
    SLOVAKIA: "SK",
    SLOVENIA: "SI",
    SPAIN: "ES",
    SWEDEN: "ES",
    "UNITED KINGDOM": "GB"
  };
  if (countries[countryCode.toUpperCase()]) {
    // console.log(countryCode.toUpperCase(),' is GDPR')
    return true;
  }

  // Object.Values not supported in IE or edge
  // if (Object.values(countries).indexOf(countryCode.toUpperCase()) > -1) {
  //   return true;
  // }

  let values = Object.keys(countries).map(function (key) {
    return countries[key];
  });
  if (values.indexOf(countryCode.toUpperCase()) > -1) {
    return true;
  }
  return false;
}